var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1513 71.4771H12.3364C10.2766 71.4771 8.60053 69.8152 8.60053 67.775V12.225C8.60053 10.1838 10.2766 8.52288 12.3364 8.52288H47.1524C49.5272 8.52288 51.4527 6.61482 51.4527 4.26144C51.4527 1.90806 49.5272 0 47.1524 0H12.3364C5.53444 0 0 5.48341 0 12.225V67.775C0 74.5166 5.53444 80 12.3364 80H47.1524C49.5272 80 51.4527 78.0919 51.4527 75.7386C51.4516 73.3852 49.5262 71.4771 47.1513 71.4771Z",
    fill: "#B1C3CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9369 36.1186L63.027 21.8896C62.0798 21.0437 60.7188 20.8296 59.5556 21.342C58.3913 21.8545 57.6409 22.9997 57.6409 24.2622V34.2297L19.5029 34.2307C17.1281 34.2307 15.2026 36.1388 15.2026 38.4922C15.2026 40.8456 17.1281 42.7536 19.5029 42.7536L57.6409 42.7525V52.7201C57.6409 53.9825 58.3913 55.1278 59.5556 55.6402C59.9759 55.8256 60.4221 55.9161 60.865 55.9161C61.6487 55.9161 62.4217 55.6328 63.0259 55.0937L78.9358 40.8647C79.6131 40.2585 80.0001 39.3956 80.0001 38.4911C80.0023 37.5866 79.6152 36.7247 78.9369 36.1186Z",
    fill: "#B1C3CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.f7d1ee212b6b24bc01cf7750e3748281.svg";
export { ForwardRef as ReactComponent };